import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Menu.svg",
  "use": "Menu.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Menu.svg\"><path d=\"M15.01,16.0209h34a2,2,0,1,1,0,4h-34a2,2,0,1,1,0-4Zm0,14h34a2,2,0,0,1,0,4h-34a2,2,0,1,1,0-4Zm0,14h34a2,2,0,0,1,0,4h-34a2,2,0,0,1,0-4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol